module.exports = __webpack_public_path__ + "img/logo_redondo.6f7acec1.png";